import React from "react";
import billingFlow from "./assets/billingFlow.jpg";

const Billing = () => {
  return (
    <div className="welcome-page-2">
      <div className="faq-page-wrapper">
        <header>
          <h1>HOW TO: Rechnungsstellung</h1>
        </header>

        <p>
          Wer bekommt meine Rechnung und wie stelle ich Rechnungen richtig aus?
        </p>
        <img className="faq-image" src={billingFlow} alt="Marketing sign" />

        <p>
          <strong>Direkte Abrechnung mit den Märkten:</strong>
        </p>

        <p>
          Als Freiraumlieferant:in musst du direkt mit den Märkten abrechnen.
          Sofern du keine eigene Streckenlistungen in den Regionen hast, erfolgt
          die Rechnungsstellung postalisch an die jeweiligen Märkte. Bei einer
          vorhandenen Streckenlistung wird die Rechnung direkt an die
          Streckenfaktura zugestellt.
        </p>

        <p>
          <strong>Und so geht&#39;s:</strong>
        </p>

        <p>
          <ol>
            <li>
              Du erhältst eine Bestellung von einem Markt, du hast also auch die
              Adresse vorliegen.
            </li>

            <li>
              Du lieferst die Ware mit deinem Lieferschein aus, am besten mit
              Abliefernachweis.
            </li>

            <li>
              Du stellst dem Markt eine Rechnung per Post. Meist ist hierbei
              Lieferadresse und Rechnungsadresse identisch.
            </li>
          </ol>
        </p>

        <p>Budni:</p>

        <p>
          Die Rechnungskontrolle für die Filialen liegt bei der EDEKA Nord. Die
          Rechnungen müssen daher per Mail an{" "}
          <a
            style={{ textDecoration: "underline" }}
            href="mailto:budni-rechnung-ware.nord@edeka.de"
          >
            budni-rechnung-ware.nord@edeka.de
          </a>{" "}
          geschickt werden.
        </p>

        <p>
          Warenempfänger sind die jeweiligen Filialen und Rechnungsempfänger
          (nur auf der Rechnung) je Gesellschaft diese beiden:
        </p>

        <p>
          Rechnungsempfänger Iwan Budnikowsky:
          <br />
          Iwan Budnikowsky GmbH & Co. KG
          <br />
          Budnikowsky-Twiete 7<br />
          22041 Hamburg
          <br />
          GLN 4305175000005
          <br />
          <br />
          Rechnungsempfänger Gesellschaft Berlin:
          <br />
          <br />
          Iwan Budnikowsky Berlin GmbH
          <br />
          Kronenstraße 63
          <br />
          10117 Berlin
          <br />
          GLN: 4260766130007
          <br />
        </p>
      </div>
    </div>
  );
};

export default Billing;
